module.exports = __webpack_public_path__ + "static/media/satellite.b591ce66.png";